import type { ElementTemplateKey } from "../types";

// Kullanıcının "hangi soru tipinde hangi form elemanları görünsün" tercihi.
// Soru tipi id'si -> görünür form-eleman şablon anahtarları.
// Backend gerektirmez; localStorage'da her oturumda kalıcıdır.
const STORAGE_KEY = "question-editor:form-element-visibility";

export type FormElementVisibilityMap = Record<string, ElementTemplateKey[]>;

export function loadFormElementVisibility(): FormElementVisibilityMap {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object") return {};

    const result: FormElementVisibilityMap = {};
    for (const [key, value] of Object.entries(
      parsed as Record<string, unknown>
    )) {
      if (Array.isArray(value)) {
        result[key] = value.filter(
          (item): item is ElementTemplateKey => typeof item === "string"
        );
      }
    }
    return result;
  } catch {
    return {};
  }
}

export function saveFormElementVisibility(map: FormElementVisibilityMap): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // storage failures (privacy mode etc.) sessizce yok sayılır
  }
}
